import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from '../hooks/useTranslation';

const AdBanner = ({ className = '', adId = 'div-gpt-ad-1765856714506-0' }) => {
  const { t } = useTranslation();
  const [adLoaded, setAdLoaded] = useState(false);
  const adRef = useRef(null);
  const displayedRef = useRef(false);

  useEffect(() => {
    // Reset on mount
    displayedRef.current = false;
    setAdLoaded(false);

    // Wait for googletag to be ready and slot to be defined
    const displayAd = () => {
      if (displayedRef.current) return;
      
      if (window.googletag && window.googletag.apiReady) {
        window.googletag.cmd.push(function() {
          try {
            window.googletag.display(adId);
            displayedRef.current = true;
            setAdLoaded(true);
          } catch (e) {
            console.log('Ad display error:', e);
          }
        });
      } else {
        // Retry after a short delay if not ready
        setTimeout(displayAd, 100);
      }
    };

    // Small delay to ensure slot is defined in head script
    const timer = setTimeout(displayAd, 500);
    
    return () => {
      clearTimeout(timer);
    };
  }, [adId]);

  return (
    <div className={`hidden md:flex justify-center overflow-x-auto ${className}`}>
      {/* /35191601/LB//BB-Top - Hidden on mobile */}
      <div 
        ref={adRef}
        id={adId}
        style={{ minWidth: '728px', minHeight: '90px' }}
        className="bg-gray-50 rounded-lg flex items-center justify-center"
      >
        {!adLoaded && (
          <div className="text-gray-400 text-sm py-8">
            {t('common.loading')}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdBanner;
